export default async function ({ app }) {
  const token = app.$apolloHelpers.getToken()
  if (app.$auth.loggedIn || token) {
    try {
      await app.$auth.setUserToken()
    } catch (e) {
      app.$auth.logout()
    }
  }
}
